/* =====================================================================
   ETERIK v2.0 · Glow crema — ek2.js (tema Shopify, base Dawn 15.5)
   Interacción del prototipo aprobado, con el carrito real de Shopify:
   · Datos: <script type="application/json" id="ek2-data"> (snippets/ek2-data.liquid).
   · Carrito: AJAX API (/cart/add.js, /cart/change.js, /cart.js). Líneas y totales salen
     SIEMPRE de /cart.js (descuentos automáticos de Shopify ya aplicados). El envío se
     muestra como en el prototipo: $150, o tachado + "Gratis" desde 3 piezas.
   · priceFor() solo muestra precios de rituales y del constructor antes de agregar.
   · API pública: window.ek2 = { add(items, opts), open(), close(), refresh(), … }
   · Compatible con el editor de temas (shopify:section:load / unload).
   ===================================================================== */
(function () {
  'use strict';

  if (window.ek2 && window.ek2.__ready) return;

  var doc = document;
  var root = doc.documentElement;
  /* iOS Safari solo aplica :active al tocar si hay un listener táctil (pasivo: no afecta el scroll) */
  doc.addEventListener('touchstart', function () {}, { passive: true });

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function byId(id) { return doc.getElementById(id); }
  function noop() {}
  /* Mejoras opcionales: si una falla, el resto de la página sigue funcionando */
  function safe(fn) { try { fn(); } catch (e) { /* mejora opcional no disponible */ } }
  function media(q) {
    return window.matchMedia ? window.matchMedia(q) : { matches: false };
  }
  function onMedia(m, fn) {
    if (m.addEventListener) m.addEventListener('change', fn);
    else if (m.addListener) m.addListener(fn);
  }
  /* Elementos (de una sección) ya inicializados: el editor de temas puede volver a pintar secciones */
  function once(el, key) {
    if (!el) return false;
    var flag = '__ek2_' + key;
    if (el[flag]) return false;
    el[flag] = true;
    return true;
  }
  /* Busca dentro del contenedor y también el propio contenedor */
  function within(scope, sel) {
    var list = $$(sel, scope);
    if (scope !== doc && scope.matches && scope.matches(sel)) list.unshift(scope);
    return list;
  }
  var reduceMQ = media('(prefers-reduced-motion: reduce)');
  var fineMQ = media('(hover: hover) and (pointer: fine)');
  var heroMQ = media('(max-aspect-ratio: 5/4)');
  var desktopMQ = media('(min-width: 900px)');
  var conn = navigator.connection || null;
  var saveData = !!(conn && conn.saveData);
  var slowNet = !!(conn && /2g|3g/.test(String(conn.effectiveType || '')));
  function reduced() { return !!reduceMQ.matches; }
  function lowMotion() { return reduced() || saveData; }
  function motionPaused() { return root.classList.contains('ek2-motion-paused'); }
  function countWord(n) { return n === 1 ? '1 producto' : n + ' productos'; }
  function pieces(n) { return n === 1 ? '1 pieza' : n + ' piezas'; }
  function tpl(str, data) {
    return String(str).replace(/\{(\w+)\}/g, function (m, k) { return Object.prototype.hasOwnProperty.call(data, k) ? data[k] : m; });
  }
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* sin almacenamiento */ } }
  };
  function safePlay(v) {
    try { var p = v.play(); if (p && typeof p.catch === 'function') p.catch(function () {}); } catch (e) { /* nada */ }
  }
  function escapeHTML(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function cssEsc(s) {
    return window.CSS && CSS.escape ? CSS.escape(String(s)) : String(s).replace(/["\\]/g, '\\$&');
  }
  function emit(name, detail) {
    try { doc.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) { /* navegador viejo */ }
  }

  /* =====================================================================
     DATOS (snippets/ek2-data.liquid): productos reales, envío fijo y promoción
     ===================================================================== */
  var DATA = {};
  safe(function () {
    var el = byId('ek2-data');
    if (el) DATA = JSON.parse(el.textContent) || {};
  });

  /* Catálogo: precio en pesos (price) y en centavos (priceCents), como lo da Shopify */
  var PRODUCTS = (DATA.products || []).map(function (p) {
    var cents = Math.round(Number(p.price) || 0);
    return {
      id: p.id, handle: p.handle, name: p.title || p.shopify_title || '', title: p.shopify_title || p.title || '',
      kind: p.kind || '', tagline: p.tagline || '', size: p.size || '', glow: p.glow || 'perla',
      variantId: Number(p.variant_id) || 0, price: cents / 100, priceCents: cents,
      available: p.available !== false, url: p.url || '', images: p.images || {}
    };
  }).filter(function (p) { return p.id && p.variantId; });

  /* Paquetes fijos (el precio sale de priceFor, nunca se escribe a mano). */
  var BUNDLES = [
    { id: 'duo-superboom',   name: 'Dúo Super Boom',  items: ['shampoo', 'acond'] },
    { id: 'duo-mascarillas', name: 'Dúo Mascarillas', items: ['glowbomb', 'reset'] },
    { id: 'ritual-glow',     name: 'Ritual Glow',     items: ['shampoo', 'acond', 'glowbomb'] },
    { id: 'ritual-reset',    name: 'Ritual Reset',    items: ['shampoo', 'acond', 'reset'] },
    { id: 'ritual-completo', name: 'Ritual Completo', items: ['shampoo', 'acond', 'glowbomb', 'reset'], tag: 'Tu mejor precio' }
  ];

  /* Promoción de lanzamiento: cuenta PIEZAS totales de la línea, en cualquier combinación.
     1 pieza: precio normal · 2: −10 % · 3: −10 % + envío gratis · 4 o más: −15 % + envío gratis.
     En el carrito manda Shopify (descuentos automáticos); esto solo es la vista previa. */
  var PROMO = (function () {
    var p = DATA.promo || {};
    var tiers = (p.tiers && p.tiers.length ? p.tiers : [{ min: 2, pct: 10 }, { min: 3, pct: 10, freeShipping: true }, { min: 4, pct: 15, freeShipping: true }])
      .map(function (t) { return { min: Number(t.min) || 0, pct: Number(t.pct) || 0 }; })
      .sort(function (a, b) { return a.min - b.min; });
    return { freeShippingFrom: Number(p.freeShippingFrom) || 3, tiers: tiers };
  })();

  /* Envío fijo a todo México (la tarifa "Envío" de Shopify). Centavos en ek2-data; pesos aquí. */
  var SHIPPING_FLAT_CENTS = Number(DATA.SHIPPING_FLAT);
  if (!(SHIPPING_FLAT_CENTS >= 0)) SHIPPING_FLAT_CENTS = 15000;
  var SHIPPING_FLAT = SHIPPING_FLAT_CENTS / 100;

  function rateFor(units) {
    var u = Math.max(0, units | 0);
    var pct = 0;
    PROMO.tiers.forEach(function (t) { if (u >= t.min) pct = t.pct / 100; });
    return pct;
  }

  /**
   * priceFor(items) — función pura para los paquetes y el constructor (vista previa).
   * items: ['shampoo', 'acond'] o [{ id: 'shampoo', qty: 2 }, ...]
   * Suma el precio normal de todas las piezas y aplica la tasa según el total de piezas.
   * Como Shopify, el descuento se calcula y redondea a centavos por línea (producto × piezas) y luego se suma.
   * Envío: SHIPPING_FLAT con 1 o 2 piezas, 0 desde 3 (y 0 sin piezas).
   */
  function priceFor(items, catalog) {
    var list = catalog || PRODUCTS;
    var index = {};
    list.forEach(function (p) { index[p.id] = p; });
    var counts = {};
    (items || []).forEach(function (it) {
      var id = typeof it === 'string' ? it : (it && it.id);
      var qty = typeof it === 'string' ? 1 : Math.max(0, Math.floor(Number(it && (it.qty != null ? it.qty : it.quantity)) || 0));
      if (!index[id] || qty <= 0) return;
      counts[id] = (counts[id] || 0) + qty;
    });
    var units = 0;
    Object.keys(counts).forEach(function (id) { units += counts[id]; });
    var pct = rateFor(units);
    var regularCents = 0;
    var totalCents = 0;
    Object.keys(counts).forEach(function (id) {
      var line = Math.round(index[id].price * 100) * counts[id];
      regularCents += line;
      totalCents += line - Math.round(line * pct);
    });
    var regular = regularCents / 100;
    var total = totalCents / 100;
    var savings = (regularCents - totalCents) / 100;
    var freeShipping = units >= PROMO.freeShippingFrom;
    var shipping = units === 0 || freeShipping ? 0 : SHIPPING_FLAT;
    var shippingSaved = freeShipping ? SHIPPING_FLAT : 0;
    return {
      regular: regular, total: total, savings: savings,
      units: units, distinct: Object.keys(counts).length,
      pct: pct, freeShipping: freeShipping,
      shipping: shipping, shippingSaved: shippingSaved,
      grandTotal: Math.round((total + shipping) * 100) / 100,
      totalSavings: Math.round((savings + shippingSaved) * 100) / 100
    };
  }

  var MXN_WHOLE = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  var MXN_CENTS = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  /* formatMoney(1234) → "$1,234" · formatMoney(895.9) → "$895.90" (centavos solo cuando los hay, como Shopify) */
  function formatMoney(amount) {
    var n = Math.round((Number(amount) || 0) * 100) / 100;
    var abs = Math.abs(n);
    var fmt = Math.round(abs * 100) % 100 === 0 ? MXN_WHOLE : MXN_CENTS;
    return (n < 0 ? '−' : '') + '$' + fmt.format(abs);
  }
  /* formatMXN(1234) → "$1,234 MXN" */
  function formatMXN(amount) { return formatMoney(amount) + ' MXN'; }
  /* Centavos de Shopify → "$1,234 MXN" */
  function centsMXN(cents) { return formatMXN((Number(cents) || 0) / 100); }
  /* formatPct(0.1) → "−10 %" (con espacio fino no separable) */
  function formatPct(pct) { return '−' + Math.round(pct * 100) + '\u202f%'; }

  var PRODUCT = {};
  var BY_VARIANT = {};
  PRODUCTS.forEach(function (p) { PRODUCT[p.id] = p; BY_VARIANT[p.variantId] = p; });
  var BUNDLE = {};
  BUNDLES.forEach(function (b) { BUNDLE[b.id] = b; });

  /* Textos dinámicos */
  var NBSP_PCT = '\u202f%';
  var T = {
    cartAria: 'Abrir carrito, {count}',
    liveAdded: '{name} se agregó al carrito.',
    liveRemoved: '{name} se quitó del carrito.',
    liveUpdated: 'Carrito actualizado: {pieces}.',
    maxQty: 'Ya tienes el máximo de 99 piezas de {name}.',
    increase: 'Agregar uno más de {name}',
    decrease: 'Quitar uno de {name}',
    qty: 'Cantidad',
    remove: 'Quitar',
    removeAria: 'Quitar {name} del carrito',
    save: 'Ahorras {amount}',
    /* Paquetes y constructor: 3+ piezas suman el envío al ahorro; 2 piezas muestran el envío aparte */
    saveFreeShip: 'Ahorras {amount} + envío gratis',
    saveShipPaid: 'Ahorras {amount} · Envío {ship}',
    shipOnly: 'Envío {ship}',
    discount: 'Descuento',
    discountLabel: 'Descuento ({pct})',
    shipFree: 'Gratis',
    shipWas: 'Antes: ',
    shipNoteFree: 'Envío gratis a todo México desde 3 piezas.',
    shipNotePaid: 'Envío fijo de {ship} a todo México. Desde 3 piezas, es gratis.',
    /* Un solo mensaje de promoción por número de piezas: carrito, toast y constructor */
    promo: [
      'Lleva 2 y ahorra 10' + NBSP_PCT + '. Desde 3 piezas, el envío es gratis.',
      'Te faltan 2 piezas para envío gratis y ahorrar {ship}. Con 1 más ya ahorras 10' + NBSP_PCT + '.',
      '¡Ya tienes 10' + NBSP_PCT + '! Te falta 1 pieza para envío gratis y ahorrar {ship}.',
      '¡Tu envío es gratis! Ya tienes 10' + NBSP_PCT + ' y con 1 pieza más llegas a 15' + NBSP_PCT + '.',
      '¡Tu envío es gratis! Y 15' + NBSP_PCT + ': tu mejor precio.'
    ],
    builderBtnDisabled: 'Elige tus piezas',
    builderBtnLong: 'Agregar {pieces} al carrito',
    builderBtnShort: 'Agregar al carrito',
    /* Lo elegido en el constructor aún no está en el carrito hasta tocar el botón */
    builderCount: '{pieces} elegidas',
    builderCountOne: '1 pieza elegida',
    menuOpen: 'Abrir menú',
    menuClose: 'Cerrar menú',
    copied: '¡Correo copiado!',
    copyFailed: 'No se pudo copiar. Selecciona el correo y cópialo a mano.',
    /* Errores del carrito real (si Shopify manda su propio mensaje, se muestra ese) */
    addError: 'No pudimos agregar tus productos al carrito. Intenta de nuevo.',
    cartError: 'No pudimos actualizar tu carrito. Intenta de nuevo.'
  };
  /* Envío fijo sin "MXN" para frases cortas ("$150"); sale de SHIPPING_FLAT */
  var SHIP = formatMoney(SHIPPING_FLAT);
  /* Con "MXN" en la línea de ahorro de paquetes y constructor, para que las dos cifras se lean igual */
  var SHIP_MXN = formatMXN(SHIPPING_FLAT);
  /* Con una suscripción en el carrito las promos por piezas no se suman (un solo % por compra): solo cuenta el envío gratis */
  function cartHasSubscription() {
    return effectiveLines().some(function (l) { return !!(l.item && l.item.selling_plan_allocation); });
  }
  function promoMsg(units, ignoreSub) {
    if (!ignoreSub && cartHasSubscription()) {
      var left = 3 - (units | 0);
      return left > 0
        ? 'Tu suscripción ya tiene 15' + NBSP_PCT + '. ' + (left === 1 ? 'Te falta 1 pieza' : 'Te faltan ' + left + ' piezas') + ' para envío gratis.'
        : '¡Tu envío es gratis! Y tu suscripción ya tiene 15' + NBSP_PCT + '.';
    }
    return tpl(T.promo[Math.max(0, Math.min(units | 0, 4))], { ship: SHIP });
  }
  /* Línea de ahorro de paquetes y constructor (vacía sin piezas) */
  function saveText(pr) {
    if (!pr || pr.units <= 0) return '';
    if (pr.freeShipping) return tpl(T.saveFreeShip, { amount: formatMXN(pr.savings) });
    if (pr.savings > 0) return tpl(T.saveShipPaid, { amount: formatMXN(pr.savings), ship: SHIP_MXN });
    return tpl(T.shipOnly, { ship: SHIP_MXN });
  }

  /* Rutas de Shopify (raíz con idioma: "/" o "/en/") */
  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (ROOT_URL.charAt(ROOT_URL.length - 1) !== '/') ROOT_URL += '/';
  var CHECKOUT_URL = ROOT_URL + 'checkout';

  /* ---------- Alto real de la barra de anuncio (puede ocupar 2 líneas en celular) ---------- */
  var chromeRO = null;
  function syncChrome() {
    var a = $('.ek2-announcement');
    var h = a ? a.getBoundingClientRect().height : 0;
    root.style.setProperty('--chrome-top', Math.ceil(h) + 'px');
  }
  function initChrome() {
    safe(function () {
      syncChrome();
      if (!('ResizeObserver' in window)) return;
      if (chromeRO) chromeRO.disconnect();
      chromeRO = new ResizeObserver(syncChrome);
      var a = $('.ek2-announcement');
      if (a) chromeRO.observe(a);
    });
  }

  /* ---------- Anuncios para lector de pantalla ---------- */
  var liveTimer = 0;
  function announce(msg) {
    var live = byId('ek2-a11y-live');
    if (!live) return;
    clearTimeout(liveTimer);
    live.textContent = '';
    liveTimer = setTimeout(function () { live.textContent = msg; }, 60);
  }

  /* ---------- Feedback de botones ("Agregar" → "¡Agregado!") ---------- */
  var flashTimers = typeof WeakMap === 'function' ? new WeakMap() : null;
  function flash(btn, ms) {
    if (!btn || !btn.querySelector || !btn.querySelector('.ek2-swap')) return;
    btn.classList.add('is-done');
    if (flashTimers) {
      clearTimeout(flashTimers.get(btn));
      flashTimers.set(btn, setTimeout(function () { btn.classList.remove('is-done'); }, ms || 1400));
    } else {
      setTimeout(function () { btn.classList.remove('is-done'); }, ms || 1400);
    }
  }
  function unflash(btn) {
    if (!btn || !btn.classList) return;
    if (flashTimers) clearTimeout(flashTimers.get(btn));
    btn.classList.remove('is-done');
  }

  /* ---------- Precios desde los datos (una sola fuente) ---------- */
  function hydratePrices(scope) {
    scope = scope || doc;
    within(scope, '[data-price]').forEach(function (el) {
      var p = PRODUCT[el.getAttribute('data-price')];
      if (p) el.textContent = formatMXN(p.price);
    });
    /* Envío fijo escrito en textos fijos (anuncio, FAQ, footer, carrito): sale de SHIPPING_FLAT */
    within(scope, '[data-ship-flat]').forEach(function (el) { el.textContent = SHIP; });
    within(scope, '[data-bundle]').forEach(function (card) {
      var b = BUNDLE[card.getAttribute('data-bundle')];
      if (!b || !b.items.every(function (id) { return !!PRODUCT[id]; })) return;
      var pr = priceFor(b.items);
      var set = function (sel, text) { var el = card.querySelector(sel); if (el) el.textContent = text; };
      set('[data-b-regular]', formatMXN(pr.regular));
      set('[data-b-total]', formatMXN(pr.total));
      set('[data-b-save]', saveText(pr));
      set('[data-b-pct]', formatPct(pr.pct));
      var ship = card.querySelector('[data-b-ship]');
      if (ship) ship.hidden = !pr.freeShipping;
    });
  }

  /* =====================================================================
     CARRITO REAL (AJAX API de Shopify)
     ===================================================================== */
  var cartState = null;      /* último /cart.js */
  var pendingQty = {};       /* key → { qty, seq }: cantidades mostradas que aún no confirma Shopify */
  var commitTimers = {};
  var seqN = 0;
  var queue = Promise.resolve();
  var drawerOpen = false;
  var lastOpener = null;
  var listGuardUntil = 0;
  var lastStatus = '';
  var statusChanged = false;
  var inertList = [];
  var fetchingCart = null;
  var lastFetchAt = 0;       /* cuándo llegó el último /cart.js (para no pedirlo de más al abrir) */
  var commitFails = 0;       /* cambios de cantidad que Shopify rechazó (el pago espera a que todo se confirme) */
  var REQUEST_TIMEOUT = 15000;

  function cartBtn(){ return byId('ek2-cart-open'); }

  /* Una petición a la vez: cada cambio parte del resultado del anterior */
  function enqueue(task) {
    var run = queue.then(task, task);
    queue = run.then(noop, noop);
    return run;
  }
  function request(path, body) {
    var opts = { method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (body) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    else opts.cache = 'no-store';
    /* Red móvil colgada: a los 15 s se corta para no trabar la cola ni el botón (cae al manejo de error normal) */
    var ctrl = typeof window.AbortController === 'function' ? new AbortController() : null;
    var timer = 0;
    if (ctrl) {
      opts.signal = ctrl.signal;
      timer = setTimeout(function () { ctrl.abort(); }, REQUEST_TIMEOUT);
    }
    return fetch(ROOT_URL + path, opts).then(function (res) {
      return res.text().then(function (txt) {
        clearTimeout(timer);
        var json = null;
        try { json = txt ? JSON.parse(txt) : null; } catch (e) { json = null; }
        if (!res.ok) {
          var err = new Error((json && (json.description || json.message)) || ('HTTP ' + res.status));
          err.status = res.status;
          err.shopify = !!(json && (json.description || json.message));
          throw err;
        }
        /* 200 que no es JSON (p. ej. redirección a /password o una página HTML): no es éxito */
        if (json === null || typeof json !== 'object') {
          var bad = new Error('Respuesta inválida');
          bad.status = res.status;
          throw bad;
        }
        return json;
      });
    }, function (err) {
      clearTimeout(timer);
      throw err;
    });
  }
  function errorText(err, fallback) {
    return err && err.shopify && err.message ? String(err.message) : fallback;
  }

  function fetchCart() {
    if (fetchingCart) return fetchingCart;
    fetchingCart = enqueue(function () { return request('cart.js'); }).then(function (cart) {
      fetchingCart = null;
      lastFetchAt = Date.now();
      setCart(cart);
      return cart;
    }, function (err) { fetchingCart = null; throw err; });
    return fetchingCart;
  }

  function lineByKey(key) {
    var items = (cartState && cartState.items) || [];
    for (var i = 0; i < items.length; i++) if (items[i].key === key) return items[i];
    return null;
  }
  function hasPending() { return Object.keys(pendingQty).length > 0; }
  /* Líneas tal como se ven (cantidades pendientes aplicadas, sin las que se quitaron) */
  function effectiveLines() {
    var items = (cartState && cartState.items) || [];
    return items.map(function (item) {
      var p = pendingQty[item.key];
      return { key: item.key, item: item, qty: p ? p.qty : item.quantity };
    }).filter(function (l) { return l.qty > 0; });
  }
  function displayUnits() {
    if (!cartState) {
      var c = byId('ek2-cart-count');
      return c ? (parseInt(c.textContent, 10) || 0) : 0;
    }
    if (!hasPending()) return cartState.item_count | 0;
    return effectiveLines().reduce(function (s, l) { return s + l.qty; }, 0);
  }
  /* Piezas de la línea Eterik (mensaje de promoción en la ficha) */
  function lineUnits(lines) {
    return lines.reduce(function (s, l) { return s + (BY_VARIANT[l.item.variant_id] ? l.qty : 0); }, 0);
  }
  function qtyOfVariant(variantId) {
    return effectiveLines().reduce(function (s, l) { return s + (Number(l.item.variant_id) === Number(variantId) ? l.qty : 0); }, 0);
  }

  function setCart(cart) {
    if (!cart || !cart.items) return;
    var before = displayUnits();
    var first = !cartState;
    cartState = cart;
    /* Lo pendiente que ya no existe en Shopify se descarta */
    Object.keys(pendingQty).forEach(function (k) { if (!lineByKey(k)) delete pendingQty[k]; });
    renderCart();
    var after = displayUnits();
    updateCount(first ? after : before, after);
    emit('ek2:cart', { cart: cart });
  }
  /* Avisa a Dawn (página /cart) que el carrito cambió desde ek2 */
  function publishToDawn(cart) {
    safe(function () {
      if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ek2', cartData: cart });
      }
    });
  }

  function updateCount(before, after) {
    var count = byId('ek2-cart-count');
    var btn = cartBtn();
    if (!count || !btn) return;
    count.textContent = after > 99 ? '99+' : String(after);
    count.setAttribute('data-empty', after > 0 ? 'false' : 'true');
    btn.setAttribute('aria-label', tpl(T.cartAria, { count: countWord(after) }));
    if (after > before && before > 0 && !reduced() && count.animate) {
      /* Si ya está rebotando no se reinicia: el número ya cambió */
      var running = count.getAnimations ? count.getAnimations().some(function (a) { return a.playState === 'running'; }) : false;
      if (!running) {
        count.animate([
          { transform: 'scale(1)' },
          { transform: 'scale(1.2)', offset: 0.4 },
          { transform: 'scale(1)' }
        ], { duration: 300, easing: 'cubic-bezier(0.23,1,0.32,1)' });
      }
    }
  }

  /* Miniatura: el CDN de Shopify redimensiona con &width= */
  function sized(url, w) {
    if (!url) return '';
    url = String(url);
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function lineInfo(item) {
    var p = BY_VARIANT[item.variant_id];
    var img = p && p.images.pack ? p.images.pack : ((item.featured_image && item.featured_image.url) || item.image || '');
    var size = p ? p.size : '';
    var variant = (!p && !item.product_has_only_default_variant && item.variant_title) ? item.variant_title : '';
    return {
      product: p || null,
      name: p ? p.name : (item.product_title || item.title || ''),
      size: size,
      variant: variant,
      img: sized(img, 180),
      plan: item.selling_plan_allocation && item.selling_plan_allocation.selling_plan ? item.selling_plan_allocation.selling_plan.name : '',
      unit: Number(item.original_price != null ? item.original_price : item.price) || 0
    };
  }

  function rowHTML(line) {
    var item = line.item;
    var info = lineInfo(item);
    var n = escapeHTML(info.name);
    var k = escapeHTML(line.key);
    return '' +
      '<li class="ek2-cart-row" data-row="' + k + '">' +
        '<div class="ek2-cart-row__img">' + (info.img ? '<img src="' + escapeHTML(info.img) + '" width="72" height="90" alt="" decoding="async">' : '') + '</div>' +
        '<div class="ek2-cart-row__info">' +
          '<p class="ek2-cart-row__name">' + n + '</p>' +
          (info.size ? '<p class="ek2-cart-row__size">' + escapeHTML(info.size) + '</p>' : '') +
          (info.variant ? '<p class="ek2-cart-row__variant">' + escapeHTML(info.variant) + '</p>' : '') +
          (info.plan ? '<p class="ek2-cart-row__variant ek2-cart-row__plan">Suscripción · ' + escapeHTML(info.plan) + '</p>' : '') +
          '<div class="ek2-stepper" role="group" aria-label="' + T.qty + ': ' + n + '">' +
            '<button class="ek2-stepper__btn" type="button" data-dec="' + k + '" data-focus-key="dec-' + k + '" aria-label="' + escapeHTML(tpl(T.decrease, { name: info.name })) + '">' +
              '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M1.5 6h9" stroke="currentColor" stroke-width="1.5"/></svg></button>' +
            '<span class="ek2-stepper__val">' + line.qty + '</span>' +
            '<button class="ek2-stepper__btn" type="button" data-inc="' + k + '" data-focus-key="inc-' + k + '" aria-label="' + escapeHTML(tpl(T.increase, { name: info.name })) + '" aria-disabled="' + (line.qty >= 99 ? 'true' : 'false') + '">' +
              '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M6 1.5v9M1.5 6h9" stroke="currentColor" stroke-width="1.5"/></svg></button>' +
          '</div>' +
        '</div>' +
        '<div class="ek2-cart-row__side">' +
          '<p class="ek2-price">' + centsMXN(info.unit * line.qty) + '</p>' +
          '<button class="ek2-btn ek2-btn--text" type="button" data-remove="' + k + '" data-focus-key="rm-' + k + '" aria-label="' + escapeHTML(tpl(T.removeAria, { name: info.name })) + '">' + T.remove + '</button>' +
        '</div>' +
      '</li>';
  }

  /* +/−: se actualiza la fila en su lugar (sin reconstruir botones ni imágenes) */
  function updateRow(row, line) {
    var info = lineInfo(line.item);
    var val = row.querySelector('.ek2-stepper__val');
    if (val) val.textContent = String(line.qty);
    var price = row.querySelector('.ek2-cart-row__side .ek2-price');
    if (price) price.textContent = centsMXN(info.unit * line.qty);
    var inc = row.querySelector('[data-inc]');
    if (inc) inc.setAttribute('aria-disabled', line.qty >= 99 ? 'true' : 'false');
  }

  var NOTICE_IDS = ['ek2-cart-notice', 'ek2-cart-empty-notice', 'ek2-cart-load-notice'];
  function clearNotices() {
    NOTICE_IDS.forEach(function (id) {
      var n = byId(id);
      if (n) { n.textContent = ''; n.classList.remove('is-visible'); }
    });
  }

  function renderCart() {
    var list = byId('ek2-cart-list');
    if (!list) return;
    if (!cartState) return; /* aún sin /cart.js: se queda lo que pintó Liquid */
    var lines = effectiveLines();
    var units = lines.reduce(function (s, l) { return s + l.qty; }, 0);
    var busy = hasPending();
    var active = doc.activeElement;
    var focusKey = active && list.contains(active) ? active.getAttribute('data-focus-key') : null;

    var rows = $$('.ek2-cart-row', list);
    var same = rows.length === lines.length && rows.every(function (r, i) { return r.getAttribute('data-row') === lines[i].key; });
    if (same) {
      lines.forEach(function (line, i) { updateRow(rows[i], line); });
    } else {
      list.innerHTML = lines.map(rowHTML).join('');
    }

    var empty = lines.length === 0;
    var set = function (id, fn) { var el = byId(id); if (el) fn(el); };
    set('ek2-cart-empty', function (el) { el.hidden = !empty; });
    set('ek2-cart-foot', function (el) { el.hidden = empty; });
    set('ek2-cart-status', function (el) { el.hidden = empty; });
    set('ek2-cart-title-count', function (el) { el.textContent = '(' + units + ')'; });

    /* Promoción por piezas + barra de progreso hacia el envío gratis (3 piezas) */
    var msg = empty ? '' : promoMsg(units);
    statusChanged = msg !== lastStatus;
    if (statusChanged) { set('ek2-cart-status-msg', function (el) { el.textContent = msg; }); lastStatus = msg; }
    $$('#ek2-cart-meter span').forEach(function (s, i) { s.classList.toggle('is-on', units >= i + 1); });

    /* Totales: Shopify manda (original_total_price = subtotal; la diferencia con total_price = descuentos automáticos) */
    var subtotal = Number(cartState.original_total_price) || 0;
    var totalProducts = Number(cartState.total_price) || 0;
    var savings = Math.max(0, subtotal - totalProducts);
    /* Mientras hay cantidades sin confirmar, los montos son del /cart.js anterior: el envío se calcula
       con esas mismas piezas para no mezclar cifras (el mensaje y la barra sí usan lo que se ve). */
    var unitsForTotals = busy ? (cartState.item_count | 0) : units;
    var freeShipping = unitsForTotals >= PROMO.freeShippingFrom;
    var shipShown = freeShipping ? 0 : SHIPPING_FLAT_CENTS;
    /* La etiqueta sale del descuento que Shopify sí aplicó: el % solo si es una tasa limpia de la promo */
    var pctShown = subtotal > 0 ? Math.round((savings / subtotal) * 100) : 0;
    var cleanPct = PROMO.tiers.some(function (t) { return t.pct === pctShown; });

    set('ek2-cart-subtotal', function (el) { el.textContent = centsMXN(subtotal); });
    set('ek2-cart-savings-row', function (el) { el.hidden = savings <= 0; });
    set('ek2-cart-savings-label', function (el) { el.textContent = savings > 0 && cleanPct ? tpl(T.discountLabel, { pct: formatPct(pctShown / 100) }) : T.discount; });
    set('ek2-cart-savings', function (el) { el.textContent = centsMXN(-savings); });
    /* Envío fijo a todo México: desde 3 piezas se tacha y se suma al ahorro (el descuento de envío lo aplica Shopify en el pago) */
    set('ek2-cart-ship-val', function (el) {
      if (freeShipping) {
        el.innerHTML = '<s class="ek2-price-old"><span class="ek2-sr-only">' + T.shipWas + '</span>' + escapeHTML(centsMXN(SHIPPING_FLAT_CENTS)) + '</s> ' + T.shipFree;
      } else {
        el.textContent = centsMXN(SHIPPING_FLAT_CENTS);
      }
    });
    set('ek2-cart-total', function (el) { el.textContent = centsMXN(totalProducts + shipShown); });
    /* Ahorro = solo el descuento de productos; el envío gratis se menciona aparte ("Ahorras $186 + envío gratis") */
    set('ek2-cart-save', function (el) {
      el.hidden = savings <= 0;
      el.textContent = freeShipping
        ? tpl(T.saveFreeShip, { amount: centsMXN(savings) })
        : tpl(T.save, { amount: centsMXN(savings) });
      el.setAttribute('aria-busy', busy ? 'true' : 'false');
    });
    set('ek2-cart-ship', function (el) { el.textContent = freeShipping ? T.shipNoteFree : tpl(T.shipNotePaid, { ship: SHIP }); });
    set('ek2-cart-sum', function (el) { el.setAttribute('aria-busy', busy ? 'true' : 'false'); });

    clearNotices();

    if (focusKey && !same) {
      var again = list.querySelector('[data-focus-key="' + cssEsc(focusKey) + '"]');
      if (again) again.focus({ preventScroll: true });
      else { var t = byId('ek2-cart-title'); if (t) t.focus({ preventScroll: true }); }
    }
  }

  function showCartError(msg) {
    /* Sin /cart.js todavía no se sabe si hay líneas: el aviso va arriba, fuera de los bloques que Liquid dejó ocultos */
    var id = !cartState ? 'ek2-cart-load-notice' : (effectiveLines().length === 0 ? 'ek2-cart-empty-notice' : 'ek2-cart-notice');
    var el = byId(id);
    NOTICE_IDS.forEach(function (other) {
      if (other === id) return;
      var o = byId(other);
      if (o) { o.textContent = ''; o.classList.remove('is-visible'); }
    });
    if (el) {
      el.classList.remove('is-visible');
      void el.offsetWidth;
      el.textContent = msg;
      el.classList.add('is-visible');
    }
    announce(msg);
  }

  /* ---------- Cambios de cantidad (la cifra cambia al instante; Shopify confirma 300 ms después) ---------- */
  function commitLine(key) {
    clearTimeout(commitTimers[key]);
    delete commitTimers[key];
    var pend = pendingQty[key];
    if (!pend) return Promise.resolve(cartState);
    var mySeq = pend.seq;
    var qty = pend.qty;
    return enqueue(function () { return request('cart/change.js', { id: key, quantity: qty }); })
      .then(function (cart) {
        if (pendingQty[key] && pendingQty[key].seq === mySeq) delete pendingQty[key];
        setCart(cart);
        publishToDawn(cart);
        return { ok: true, cart: cart };
      }, function (err) {
        commitFails++;
        if (pendingQty[key] && pendingQty[key].seq === mySeq) delete pendingQty[key];
        var msg = errorText(err, T.cartError);
        return fetchCart().then(function () { showCartError(msg); }, function () { renderCart(); showCartError(msg); })
          .then(function () { return { ok: false }; });
      });
  }
  /* Guarda en Shopify lo pendiente (y espera lo que ya iba en camino).
     Resuelve true si todo se confirmó; false si Shopify rechazó algún cambio. */
  function flushPending() {
    var keys = Object.keys(commitTimers);
    if (!keys.length && !hasPending()) return Promise.resolve(true);
    var failsBefore = commitFails;
    var own = keys.map(function (k) { return commitLine(k); });
    return Promise.all(own).then(function (results) {
      return queue.then(function () {
        return commitFails === failsBefore && results.every(function (r) { return !r || r.ok !== false; });
      });
    });
  }
  function setLineQty(key, next) {
    var item = lineByKey(key);
    if (!item) return;
    /* Tope de 99 solo al subir: si ya había más (p. ej. 120), "−" quita una, no todas las de más */
    next = Math.max(0, next | 0);
    if (next > currentQty(key)) next = Math.min(99, next);
    if (next <= 0) { removeLine(key); return; }
    pendingQty[key] = { qty: next, seq: ++seqN };
    var before = displayUnits();
    renderCart();
    updateCount(before, displayUnits());
    announceQty(key);
    clearTimeout(commitTimers[key]);
    commitTimers[key] = setTimeout(function () { commitLine(key); }, 300);
  }
  function currentQty(key) {
    var p = pendingQty[key];
    if (p) return p.qty;
    var item = lineByKey(key);
    return item ? item.quantity : 0;
  }

  /* Quitar es inmediato (respuesta del sistema). Un toque doble no alcanza a la fila que sube. */
  function removeLine(key) {
    var item = lineByKey(key);
    if (!item) return;
    var info = lineInfo(item);
    var list = byId('ek2-cart-list');
    var rows = $$('.ek2-cart-row', list);
    var index = rows.indexOf(list.querySelector('[data-row="' + cssEsc(key) + '"]'));
    clearTimeout(commitTimers[key]);
    delete commitTimers[key];
    pendingQty[key] = { qty: 0, seq: ++seqN };
    var before = displayUnits();
    renderCart();
    updateCount(before, displayUnits());
    listGuardUntil = Date.now() + 350;
    announce(tpl(T.liveRemoved, { name: info.name }) + (statusChanged && lastStatus ? ' ' + lastStatus : ''));
    var left = $$('.ek2-cart-row', list);
    if (drawerOpen) {
      if (left.length) {
        var target = left[Math.min(Math.max(index, 0), left.length - 1)].querySelector('[data-remove]');
        if (target) target.focus({ preventScroll: true });
      } else {
        var cta = byId('ek2-cart-empty-cta');
        if (cta) cta.focus({ preventScroll: true });
      }
    }
    commitLine(key);
  }

  function announceQty(key) {
    var item = lineByKey(key);
    if (!item) return;
    var info = lineInfo(item);
    announce(info.name + ': ' + pieces(currentQty(key)) + '. ' + pieces(displayUnits()) + ' en tu carrito.' + (statusChanged && lastStatus ? ' ' + lastStatus : ''));
  }

  /* ---------- Agregar ---------- */
  /* items: ['shampoo', ...] · [{ id: 'shampoo', qty: 2 }] · [{ id: <variante numérica>, quantity: n }] */
  function normalizeItems(items) {
    var map = {};
    var order = [];
    (Array.isArray(items) ? items : [items]).forEach(function (it) {
      if (it == null) return;
      var id;
      var qty;
      var plan = 0;
      if (typeof it === 'string' || typeof it === 'number') { id = it; qty = 1; }
      else {
        id = it.id != null ? it.id : it.variant_id;
        qty = it.quantity != null ? it.quantity : (it.qty != null ? it.qty : 1);
        plan = Number(it.selling_plan) || 0;
      }
      qty = Math.max(0, Math.floor(Number(qty) || 0));
      var p = PRODUCT[id];
      var variantId = p ? p.variantId : Number(id);
      if (!variantId || !qty) return;
      var key = variantId + '|' + plan;
      if (!Object.prototype.hasOwnProperty.call(map, key)) { map[key] = { id: variantId, quantity: 0, plan: plan }; order.push(key); }
      map[key].quantity += qty;
    });
    return order.map(function (k) {
      var l = map[k];
      return l.plan ? { id: l.id, quantity: l.quantity, selling_plan: l.plan } : { id: l.id, quantity: l.quantity };
    });
  }

  /**
   * ek2.add(items, opts) → Promise<cart>
   * opts.button: botón que muestra "¡Agregado!" · opts.open: abrir el carrito (por defecto: sí con
   * varios productos, como los rituales; con uno solo se muestra el aviso "toast").
   * En error (p. ej. 422) abre el carrito con el mensaje y la promesa se rechaza.
   */
  function add(items, opts) {
    opts = opts || {};
    var btn = opts.button || null;
    var lines = normalizeItems(items);
    if (!lines.length) return Promise.reject(new Error('ek2.add: no hay productos válidos'));
    var openAfter = opts.open != null ? !!opts.open : lines.length > 1;
    /* Tope de 99 piezas por producto: se recorta lo que se agrega (60 + 60 → 60 + 39) */
    if (cartState) {
      var capped = null;
      lines = lines.filter(function (l) {
        var room = 99 - qtyOfVariant(l.id);
        if (l.quantity > room) { l.quantity = Math.max(0, room); if (!capped) capped = l.id; }
        return l.quantity > 0;
      });
      if (capped) {
        var p99 = BY_VARIANT[capped];
        announce(tpl(T.maxQty, { name: p99 ? p99.name : '' }));
      }
      if (!lines.length) return Promise.resolve(cartState);
    }
    if (btn) {
      if (btn.getAttribute('aria-busy') === 'true') return Promise.resolve(cartState);
      btn.setAttribute('aria-busy', 'true');
      flash(btn); /* respuesta inmediata, como en el prototipo; se revierte si Shopify rechaza */
    }
    var added = null;
    var addOk = false;
    return flushPending()
      .then(function () { return enqueue(function () { return request('cart/add.js', { items: lines }); }); })
      .then(function (res) {
        addOk = true;
        added = res && res.items ? res.items : null;
        return fetchCart();
      })
      .then(function (cart) {
        if (btn) btn.removeAttribute('aria-busy');
        var units = displayUnits();
        publishToDawn(cart);
        if (openAfter) {
          openCart(btn || cartBtn());
          announce(tpl(T.liveUpdated, { pieces: pieces(units) }) + ' ' + promoMsg(units));
        } else {
          var first = added && added[0] ? added[0] : null;
          var name = showToast(lines[0].id, first);
          announce(tpl(T.liveAdded, { name: name }) + ' ' + promoMsg(units));
        }
        emit('ek2:added', { items: lines, cart: cart });
        return cart;
      })
      .catch(function (err) {
        /* Shopify sí agregó, pero no se pudo leer el carrito: no se dice "no pudimos agregar"
           (reintentar duplicaría piezas). Se reintenta la lectura una vez y se avisa con el error de actualizar. */
        if (addOk) {
          if (btn) btn.removeAttribute('aria-busy');
          return fetchCart().then(function (cart) {
            publishToDawn(cart);
            openCart(btn || cartBtn());
            return cart;
          }, function () {
            openCart(btn || cartBtn());
            showCartError(T.cartError);
            return cartState;
          });
        }
        if (btn) { btn.removeAttribute('aria-busy'); unflash(btn); }
        var msg = errorText(err, T.addError);
        return fetchCart().catch(noop).then(function () {
          openCart(btn || cartBtn());
          showCartError(msg);
          throw err;
        });
      });
  }

  function refresh() { return fetchCart(); }

  /* ---------- Abrir / cerrar el drawer ---------- */
  var SKIP_INERT = { SCRIPT: 1, STYLE: 1, LINK: 1, TEMPLATE: 1, NOSCRIPT: 1, META: 1 };
  /* Todo lo que no es #ek2-overlays queda inerte mientras el carrito está abierto */
  function setPageInert(on) {
    if (!on) {
      inertList.forEach(function (el) { el.removeAttribute('inert'); });
      inertList = [];
      return;
    }
    var node = byId('ek2-overlays');
    inertList = [];
    while (node && node.parentElement && node !== doc.body) {
      var parent = node.parentElement;
      Array.prototype.forEach.call(parent.children, function (sib) {
        if (sib === node || SKIP_INERT[sib.tagName] || sib.hasAttribute('inert')) return;
        sib.setAttribute('inert', '');
        inertList.push(sib);
      });
      node = parent;
    }
  }
  function focusables(container) {
    return $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.getClientRects().length > 0 && !el.closest('[hidden]'); });
  }
  function openCart(opener) {
    var drawer = byId('ek2-cart');
    if (!drawer || drawerOpen) return;
    closeMenu(false);
    hideToast();
    lastOpener = opener || doc.activeElement;
    drawerOpen = true;
    drawer.removeAttribute('inert');
    drawer.classList.add('is-open');
    var scrim = byId('ek2-cart-scrim');
    if (scrim) scrim.classList.add('is-open');
    setPageInert(true);
    root.classList.add('ek2-locked');
    var btn = cartBtn();
    if (btn) btn.setAttribute('aria-expanded', 'true');
    var title = byId('ek2-cart-title');
    if (title) title.focus({ preventScroll: true });
    /* Siempre se sincroniza (otra pestaña o el pago pudieron cambiarlo), salvo si se acaba de leer */
    if (!cartState || (!hasPending() && Date.now() - lastFetchAt > 2000)) {
      fetchCart().catch(function (err) { showCartError(errorText(err, T.cartError)); });
    }
  }
  function closeCart(returnFocus) {
    if (!drawerOpen) return;
    drawerOpen = false;
    var drawer = byId('ek2-cart');
    if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('inert', ''); }
    var scrim = byId('ek2-cart-scrim');
    if (scrim) scrim.classList.remove('is-open');
    setPageInert(false);
    root.classList.remove('ek2-locked');
    var btn = cartBtn();
    if (btn) btn.setAttribute('aria-expanded', 'false');
    clearNotices();
    if (returnFocus !== false) {
      var target = lastOpener && lastOpener.isConnected && lastOpener.getClientRects().length && !lastOpener.closest('[inert]') ? lastOpener : btn;
      try { if (target) target.focus({ preventScroll: true }); } catch (e) { if (btn) btn.focus(); }
    }
    lastOpener = null;
  }

  /* =====================================================================
     TOAST
     ===================================================================== */
  var toastTimer = 0;
  var toastHover = false;
  var toastVisible = false;
  var swapTimer = 0;
  var pendingToast = null;
  /* Devuelve el nombre mostrado (para el anuncio) */
  function fillToast(variantId, addedItem) {
    var p = BY_VARIANT[variantId];
    var name = p ? p.name : (addedItem ? (addedItem.product_title || addedItem.title || '') : '');
    var img = p ? p.images.cut : (addedItem ? ((addedItem.featured_image && addedItem.featured_image.url) || addedItem.image || '') : '');
    var thumb = byId('ek2-toast-thumb');
    if (thumb) thumb.setAttribute('data-glow', p ? p.glow : 'perla');
    var im = byId('ek2-toast-img');
    if (im) { if (img) im.src = sized(img, 120); else im.removeAttribute('src'); }
    var m = byId('ek2-toast-msg');
    if (m) m.textContent = tpl(T.liveAdded, { name: name });
    var h = byId('ek2-toast-hint');
    if (h) h.textContent = promoMsg(displayUnits());
    return name;
  }
  function armToastTimer() {
    clearTimeout(toastTimer);
    if (toastHover || doc.hidden) return;
    toastTimer = setTimeout(hideToast, 3500);
  }
  function showToast(variantId, addedItem) {
    var toast = byId('ek2-toast');
    var inner = byId('ek2-toast-inner');
    var p = BY_VARIANT[variantId];
    var name = p ? p.name : (addedItem ? (addedItem.product_title || addedItem.title || '') : '');
    if (!toast || !inner) return name;
    bindToast(toast);
    if (toastVisible) {
      /* Un solo cambio de contenido en curso; se muestra el último producto agregado */
      pendingToast = [variantId, addedItem];
      if (!swapTimer) {
        inner.classList.add('is-swapping');
        swapTimer = setTimeout(function () {
          fillToast(pendingToast[0], pendingToast[1]);
          inner.classList.remove('is-swapping');
          swapTimer = 0;
        }, reduced() ? 0 : 150);
      }
    } else {
      fillToast(variantId, addedItem);
      var header = byId('ek2-site-header');
      if (desktopMQ.matches && header) toast.style.top = Math.max(0, Math.round(header.getBoundingClientRect().bottom)) + 16 + 'px';
      else toast.style.top = '';
      toast.classList.add('is-prep');
      void toast.offsetWidth;
      toast.classList.remove('is-prep');
      toast.classList.add('is-visible');
      toastVisible = true;
      /* Después de la entrada (el toast llega con translateY) */
      setTimeout(queueChatLift, 260);
    }
    armToastTimer();
    return name;
  }
  function hideToast() {
    clearTimeout(toastTimer);
    clearTimeout(swapTimer);
    swapTimer = 0;
    var inner = byId('ek2-toast-inner');
    if (inner) inner.classList.remove('is-swapping');
    var toast = byId('ek2-toast');
    if (toast) toast.classList.remove('is-visible');
    toastVisible = false;
    queueChatLift();
  }
  function bindToast(toast) {
    if (!once(toast, 'toast')) return;
    /* Solo mouse real: el mouseenter emulado de iOS al tocar no debe congelar el toast */
    toast.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'mouse') return; toastHover = true; clearTimeout(toastTimer); });
    toast.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'mouse') return; toastHover = false; if (toastVisible) armToastTimer(); });
    toast.addEventListener('focusin', function () { toastHover = true; clearTimeout(toastTimer); });
    toast.addEventListener('focusout', function () { toastHover = false; if (toastVisible) armToastTimer(); });
  }
  doc.addEventListener('visibilitychange', function () {
    if (!toastVisible) return;
    if (doc.hidden) clearTimeout(toastTimer); else armToastTimer();
  });

  /* =====================================================================
     BOTÓN DE CHAT (Shopify Inbox, abajo a la derecha): en celular sube por encima
     del resumen pegajoso de "Arma tu ritual" y del aviso del carrito
     ===================================================================== */
  var chatLiftRaf = 0;
  var chatLift = 0;
  /* El botón vive en shadow DOM; Inbox lo expone como ::part(activator) */
  function chatButton() {
    var host = doc.querySelector('shopify-chat');
    var runtime = host && host.shadowRoot && host.shadowRoot.querySelector('shopify-agent-runtime');
    return runtime && runtime.shadowRoot && runtime.shadowRoot.querySelector('[part~="activator"]');
  }
  function lifted(el, chatBottom) {
    if (!el) return 0;
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight;
    /* Solo cuenta si el elemento ocupa la franja de abajo de la pantalla */
    if (!r.height || r.top >= vh || r.bottom < vh - r.height - 40) return 0;
    return Math.max(0, chatBottom - (r.top - 10));
  }
  function updateChatLift() {
    chatLiftRaf = 0;
    var btn = chatButton();
    var lift = 0;
    if (btn && !desktopMQ.matches) {
      /* Posición sin el desplazamiento que ya tiene (también a media transición) */
      var shift = 0;
      try { shift = new DOMMatrixReadOnly(getComputedStyle(btn).transform).m42; } catch (e) { shift = -chatLift; }
      var bottom = btn.getBoundingClientRect().bottom - shift;
      lift = Math.max(lifted(byId('ek2-builder-summary'), bottom), toastVisible ? lifted(byId('ek2-toast'), bottom) : 0);
    }
    chatLift = Math.round(lift);
    doc.documentElement.style.setProperty('--ek2-chat-lift', chatLift + 'px');
  }
  function queueChatLift() { if (!chatLiftRaf) chatLiftRaf = window.requestAnimationFrame(updateChatLift); }
  window.addEventListener('scroll', queueChatLift, { passive: true });
  window.addEventListener('resize', queueChatLift);

  /* =====================================================================
     MENÚ MÓVIL
     ===================================================================== */
  var menuOpen = false;
  function openMenu() {
    var menu = byId('ek2-mobile-menu');
    var menuBtn = byId('ek2-menu-toggle');
    var scrim = byId('ek2-menu-scrim');
    var header = byId('ek2-site-header');
    if (!menu || !menuBtn) return;
    var top = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
    menu.style.top = top + 'px';
    menu.style.maxHeight = 'calc(100dvh - ' + top + 'px)';
    if (scrim) scrim.style.top = top + 'px';
    menuOpen = true;
    menu.classList.add('is-open');
    if (scrim) scrim.classList.add('is-open');
    menuBtn.setAttribute('aria-expanded', 'true');
    menuBtn.setAttribute('aria-label', T.menuClose);
    root.classList.add('ek2-locked');
    var first = $('a', menu);
    if (first) first.focus({ preventScroll: true });
  }
  function closeMenu(returnFocus) {
    if (!menuOpen) return;
    menuOpen = false;
    var menu = byId('ek2-mobile-menu');
    var menuBtn = byId('ek2-menu-toggle');
    var scrim = byId('ek2-menu-scrim');
    if (menu) menu.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-open');
    if (menuBtn) {
      menuBtn.setAttribute('aria-expanded', 'false');
      menuBtn.setAttribute('aria-label', T.menuOpen);
    }
    if (!drawerOpen) root.classList.remove('ek2-locked');
    if (returnFocus && menuBtn) menuBtn.focus({ preventScroll: true });
  }
  onMedia(desktopMQ, function () { if (desktopMQ.matches) closeMenu(false); });

  /* =====================================================================
     CLICS (delegados en el documento: sobreviven a que el editor vuelva a pintar una sección)
     ===================================================================== */
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var el;

    /* Carrito */
    if ((el = t.closest('#ek2-cart-open'))) { openCart(el); return; }
    if (t.closest('#ek2-cart-close') || t.closest('#ek2-cart-continue') || t.closest('#ek2-cart-scrim')) { closeCart(); return; }
    if (t.closest('#ek2-toast-view')) { openCart(cartBtn()); return; }
    if (t.closest('#ek2-cart-empty-cta')) {
      closeCart(false);
      var target = byId('productos');
      if (target) {
        target.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
        var h = byId('ek2-productos-title');
        if (h) h.focus({ preventScroll: true });
      } else {
        window.location.href = ROOT_URL + '#productos';
      }
      return;
    }
    if ((el = t.closest('#ek2-cart-checkout'))) {
      /* Si hay cantidades sin confirmar, primero se guardan en Shopify */
      if (hasPending() || Object.keys(commitTimers).length) {
        e.preventDefault();
        el.setAttribute('aria-busy', 'true');
        flushPending().then(function (ok) {
          if (ok) { window.location.href = el.getAttribute('href') || CHECKOUT_URL; return; }
          el.removeAttribute('aria-busy'); /* el aviso de error ya quedó visible en el carrito */
        }, function () { el.removeAttribute('aria-busy'); });
      }
      return;
    }
    if ((el = t.closest('#ek2-cart-list button'))) {
      if (Date.now() < listGuardUntil || el.getAttribute('aria-disabled') === 'true') return;
      var key;
      if ((key = el.getAttribute('data-inc'))) {
        if (currentQty(key) >= 99) return;
        setLineQty(key, currentQty(key) + 1);
      } else if ((key = el.getAttribute('data-dec'))) {
        if (currentQty(key) <= 1) { removeLine(key); return; }
        setLineQty(key, currentQty(key) - 1);
      } else if ((key = el.getAttribute('data-remove'))) {
        removeLine(key);
      }
      return;
    }

    /* Menú móvil */
    if (t.closest('#ek2-menu-toggle')) { if (menuOpen) closeMenu(true); else openMenu(); return; }
    if (t.closest('#ek2-menu-scrim')) { closeMenu(true); return; }
    if (t.closest('#ek2-mobile-menu a')) { closeMenu(false); }

    /* Botones de agregar en toda la página (data-add = id interno o variante numérica) */
    if ((el = t.closest('[data-add]'))) {
      if (el.disabled || el.getAttribute('aria-disabled') === 'true') return;
      var qty = Number(el.getAttribute('data-qty')) || 1;
      var from = el.getAttribute('data-qty-from');
      if (from) { var inp = $(from); if (inp) qty = Math.max(1, Math.floor(Number(inp.value) || 1)); }
      add([{ id: el.getAttribute('data-add'), quantity: qty, selling_plan: el.getAttribute('data-selling-plan') || 0 }], { button: el, open: false }).catch(noop);
      return;
    }
    if ((el = t.closest('[data-add-bundle]'))) {
      var b = BUNDLE[el.getAttribute('data-add-bundle')];
      if (b) add(b.items, { button: el, open: true }).catch(noop);
      return;
    }

    /* Acordeones (fichas, ingredientes, FAQ) */
    if ((el = t.closest('.ek2-acc__btn'))) {
      var acc = el.closest('.ek2-acc');
      var open = el.getAttribute('aria-expanded') !== 'true';
      el.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (acc) acc.classList.toggle('is-open', open);
      var lbl = el.querySelector('[data-closed]');
      if (lbl) lbl.textContent = open ? lbl.getAttribute('data-open') : lbl.getAttribute('data-closed');
      return;
    }
    /* Enlaces que llevan a una pregunta (footer "Envíos" → FAQ 7): la abren si está cerrada; el ancla hace el scroll */
    if ((el = t.closest('a[data-open-acc]'))) {
      var q = byId(el.getAttribute('data-open-acc'));
      if (q && q.getAttribute('aria-expanded') !== 'true') q.click();
      return;
    }

    if (t.closest('a[href="#"]')) e.preventDefault();
  });

  /* Teclado: Escape cierra; Tab queda atrapado en el carrito; el menú devuelve el foco al botón */
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      if (drawerOpen) { e.preventDefault(); closeCart(); }
      else if (menuOpen) { e.preventDefault(); closeMenu(true); }
      return;
    }
    if (e.key !== 'Tab') return;
    var drawer = byId('ek2-cart');
    if (drawerOpen && drawer) {
      var f = focusables(drawer);
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0];
      var last = f[f.length - 1];
      var title = byId('ek2-cart-title');
      if (!drawer.contains(doc.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && (doc.activeElement === first || doc.activeElement === title)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
      return;
    }
    var menu = byId('ek2-mobile-menu');
    if (menuOpen && menu && menu.contains(doc.activeElement)) {
      var m = focusables(menu);
      if (m.length && !e.shiftKey && doc.activeElement === m[m.length - 1]) {
        e.preventDefault();
        var mb = byId('ek2-menu-toggle');
        if (mb) mb.focus();
      }
    }
  });

  /* =====================================================================
     HERO: video por matchMedia, sin video con reduced-motion, Save-Data o red lenta.
     Se carga después del evento load para no competir con la foto y las fuentes.
     ===================================================================== */
  var heroSync = function () {};
  function initHeroVideo(scope) {
    var v = within(scope, '#ek2-hero-video')[0];
    if (!v || !once(v, 'hero')) return;
    var img = $('.ek2-hero__media img');
    var current = '';
    var failed = {};
    var armed = false;
    var inView = true;
    v.muted = true;
    v.addEventListener('playing', function () { v.classList.add('is-playing'); });
    v.addEventListener('error', function () {
      if (current) failed[current] = true;
      v.classList.remove('is-playing');
    });
    function stop() {
      v.classList.remove('is-playing');
      try { v.pause(); } catch (e) { /* nada */ }
      if (v.getAttribute('src')) { v.removeAttribute('src'); try { v.load(); } catch (e) { /* nada */ } }
      current = '';
    }
    function apply() {
      if (!armed || !v.isConnected) return;
      if (lowMotion() || slowNet) { stop(); return; }
      var src = heroMQ.matches ? v.getAttribute('data-src-mobile') : v.getAttribute('data-src-desktop');
      if (!src || failed[src] || src === current) return;
      v.classList.remove('is-playing');
      current = src;
      var poster = img && (img.currentSrc || img.src);
      if (poster) v.setAttribute('poster', poster);
      v.autoplay = !motionPaused();
      v.src = src;
      if (!motionPaused() && inView) safePlay(v);
    }
    heroSync = function () {
      if (!armed) return;
      if (!current) { apply(); return; }
      if (motionPaused() || !inView) { try { v.pause(); } catch (e) { /* nada */ } }
      else safePlay(v);
    };
    onMedia(heroMQ, apply);
    onMedia(reduceMQ, apply);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          inView = en.isIntersecting;
          if (!current) return;
          if (inView && !motionPaused()) safePlay(v); else { try { v.pause(); } catch (e) { /* nada */ } }
        });
      }).observe(v.closest('.ek2-hero'));
    }
    function arm() { armed = true; apply(); }
    if (doc.readyState === 'complete') arm();
    else window.addEventListener('load', arm, { once: true });
  }

  /* Pausar / reanudar animaciones (video del hero + cinta de sellos) — WCAG 2.2.2 */
  function initMotionToggle(scope) {
    var btn = within(scope, '#ek2-motion-toggle')[0];
    if (!btn || !once(btn, 'motion')) return;
    function set(paused) {
      root.classList.toggle('ek2-motion-paused', paused);
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      store.set('eterik-motion-paused', paused ? '1' : '0');
      heroSync();
    }
    btn.setAttribute('aria-pressed', motionPaused() ? 'true' : 'false');
    btn.addEventListener('click', function () { set(!motionPaused()); });
  }

  /* Momento de carga del hero: espera las fuentes y la foto (máx. 1.2 s) */
  function heroReady() {
    var go = function () { requestAnimationFrame(function () { root.classList.add('ek2-ready'); }); };
    var fonts = doc.fonts && doc.fonts.ready ? doc.fonts.ready : Promise.resolve();
    var heroImg = $('.ek2-hero__media img');
    var imgReady = heroImg && heroImg.decode ? heroImg.decode().catch(function () {}) : Promise.resolve();
    Promise.race([Promise.all([fonts, imgReady]), new Promise(function (r) { setTimeout(r, 1200); })]).then(go, go);
  }

  /* =====================================================================
     TARJETAS: escena float-* / video loop-* (hover fino) o botón "Ver escena" (táctil)
     ===================================================================== */
  var cardIO = null;
  function initCards(scope) {
    var cards = within(scope, '.ek2-card').filter(function (c) { return once(c, 'card'); });
    if (!cards.length) return;
    if (!cardIO && 'IntersectionObserver' in window) {
      cardIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target.querySelector('.ek2-card__loop');
          if (!v || !v.getAttribute('src')) return;
          if (!en.isIntersecting) { try { v.pause(); } catch (e) { /* nada */ } }
          else if (en.target.classList.contains('is-scene') && !lowMotion()) safePlay(v);
        });
      });
    }
    cards.forEach(function (card) {
      var video = $('.ek2-card__loop', card);
      var toggle = $('.ek2-card__scene-toggle', card);
      var sheen = $('.ek2-card__sheen', card);
      var intent = 0;
      var pauseTimer = 0;
      if (video) {
        video.muted = true;
        video.addEventListener('playing', function () { video.classList.add('is-playing'); });
        video.addEventListener('error', function () { video.setAttribute('data-failed', '1'); video.classList.remove('is-playing'); });
      }
      /* El brillo pasa una sola vez por tarjeta */
      if (sheen) sheen.addEventListener('transitionend', function (e) {
        if (e.propertyName === 'transform' && card.classList.contains('is-scene')) card.setAttribute('data-sheen-done', '');
      });
      function enter() {
        clearTimeout(pauseTimer);
        card.classList.add('is-scene');
        if (toggle) toggle.setAttribute('aria-pressed', 'true');
        if (video && !lowMotion() && !video.hasAttribute('data-failed')) {
          if (!video.getAttribute('src')) video.src = video.getAttribute('data-src');
          safePlay(video);
        }
      }
      function leave() {
        clearTimeout(intent);
        card.classList.remove('is-scene');
        if (toggle) toggle.setAttribute('aria-pressed', 'false');
        if (video) {
          clearTimeout(pauseTimer);
          pauseTimer = setTimeout(function () {
            if (!card.classList.contains('is-scene')) { try { video.pause(); } catch (e) { /* nada */ } }
          }, 260);
        }
      }
      card.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse' || !fineMQ.matches) return;
        clearTimeout(intent);
        intent = setTimeout(enter, 80);
      });
      card.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        leave();
      });
      if (toggle) toggle.addEventListener('click', function () {
        if (card.classList.contains('is-scene')) leave(); else enter();
      });
      if (cardIO) cardIO.observe(card);
    });
  }

  /* =====================================================================
     PESTAÑAS (Shampoo | Acondicionador · Glow Bomb | Reset Shot)
     ===================================================================== */
  function initTabs(scope) {
    within(scope, '.ek2-seg[role="tablist"]').forEach(function (seg) {
      if (!once(seg, 'tabs')) return;
      var tabs = $$('[role="tab"]', seg);
      function select(i, focus) {
        /* Con teclado no se anima: el indicador salta y el panel aparece sin keyframes */
        if (focus) {
          seg.classList.add('no-anim');
          requestAnimationFrame(function () { requestAnimationFrame(function () { seg.classList.remove('no-anim'); }); });
        }
        tabs.forEach(function (t, j) {
          var on = i === j;
          var panel = byId(t.getAttribute('aria-controls'));
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (!panel) return;
          if (on && panel.hidden) {
            panel.hidden = false;
            panel.classList.remove('is-entering');
            if (!reduced() && !focus) { void panel.offsetWidth; panel.classList.add('is-entering'); }
          } else if (!on) {
            panel.hidden = true;
          }
        });
        seg.setAttribute('data-active', String(i));
        if (focus) tabs[i].focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          var k = e.key;
          var n = tabs.length;
          var next = null;
          if (k === 'ArrowRight') next = (i + 1) % n;
          else if (k === 'ArrowLeft') next = (i - 1 + n) % n;
          else if (k === 'Home') next = 0;
          else if (k === 'End') next = n - 1;
          if (next !== null) { e.preventDefault(); select(next, true); }
        });
      });
    });
  }

  /* =====================================================================
     CONSTRUCTOR "ARMA TU RITUAL" (piezas y cantidades, 0–99 por producto)
     ===================================================================== */
  function initBuilder(scope) {
    var builder = within(scope, '.ek2-builder')[0];
    if (!builder || !once(builder, 'builder')) return;
    var chips = $$('[data-chip]', builder);
    var addBtn = byId('ek2-builder-add');
    if (!chips.length || !addBtn) return;
    var qty = {};
    var lastPct = -1;
    var lastChange = '';

    function builderItems() {
      return PRODUCTS.filter(function (p) { return qty[p.id] > 0; }).map(function (p) { return { id: p.id, qty: qty[p.id] }; });
    }

    function swapBand(pct) {
      var band = byId('ek2-builder-pct');
      if (!band) return;
      band.classList.toggle('is-off', pct <= 0);
      if (pct <= 0 || pct === lastPct) { lastPct = pct; return; }
      var text = formatPct(pct);
      /* Toques rápidos: se borran los textos que iban saliendo para que nunca se acumulen */
      $$('.is-leaving', band).forEach(function (sp) { if (sp.parentNode) sp.parentNode.removeChild(sp); });
      var old = band.querySelector('span:not(.is-leaving)');
      if (lastPct <= 0 || reduced() || !old) {
        band.innerHTML = '<span>' + text + '</span>';
        lastPct = pct;
        return;
      }
      var goingUp = pct > lastPct;
      var incoming = doc.createElement('span');
      incoming.textContent = text;
      incoming.className = 'is-entering';
      if (!goingUp) incoming.style.transform = 'translateY(-100%)';
      band.appendChild(incoming);
      void incoming.offsetWidth;
      incoming.className = '';
      incoming.style.transform = '';
      old.classList.add('is-leaving');
      old.setAttribute('aria-hidden', 'true');
      if (!goingUp) old.style.transform = 'translateY(100%)';
      setTimeout(function () { if (old.parentNode) old.parentNode.removeChild(old); }, 220);
      lastPct = pct;
    }

    function setText(id, text) { var el = byId(id); if (el) el.textContent = text; }

    function render() {
      var items = builderItems();
      var pr = priceFor(items);
      var n = pr.units;
      chips.forEach(function (chip) {
        var id = chip.getAttribute('data-chip');
        var q = qty[id] || 0;
        chip.classList.toggle('is-on', q > 0);
        setText('ek2-builder-qty-' + id, String(q));
        var dec = byId('ek2-builder-dec-' + id);
        if (dec) dec.setAttribute('aria-disabled', q <= 0 ? 'true' : 'false');
        var inc = byId('ek2-builder-inc-' + id);
        if (inc) inc.setAttribute('aria-disabled', q >= 99 ? 'true' : 'false');
      });
      $$('[data-stage]', builder).forEach(function (item) {
        item.classList.toggle('is-on', (qty[item.getAttribute('data-stage')] || 0) > 0);
      });
      $$('.ek2-meter__seg', builder).forEach(function (s) {
        s.classList.toggle('is-on', n >= Number(s.getAttribute('data-tier')));
      });
      var hint = promoMsg(n, true);
      setText('ek2-builder-hint', hint);
      setText('ek2-builder-count', n === 1 ? T.builderCountOne : n > 1 ? tpl(T.builderCount, { pieces: pieces(n) }) : pieces(n));
      setText('ek2-builder-regular', formatMXN(pr.regular));
      var wrap = byId('ek2-builder-regular-wrap');
      if (wrap) wrap.classList.toggle('is-off', pr.savings <= 0);
      setText('ek2-builder-total', formatMXN(pr.total));
      setText('ek2-builder-save', saveText(pr));
      var ship = byId('ek2-builder-ship');
      if (ship) ship.hidden = !pr.freeShipping;
      swapBand(pr.pct);
      /* Un solo anuncio por toque: todo vive en #ek2-builder-live */
      setText('ek2-builder-hint-sr', (lastChange ? lastChange + ' ' : '') + hint);
      addBtn.setAttribute('aria-disabled', n < 1 ? 'true' : 'false');
      var label = byId('ek2-builder-add-label');
      if (label) {
        if (n < 1) label.textContent = T.builderBtnDisabled;
        else label.innerHTML = '<span class="ek2-btn-label--long">' + tpl(T.builderBtnLong, { pieces: pieces(n) }) + '</span><span class="ek2-btn-label--short">' + T.builderBtnShort + '</span>';
      }
      queueChatLift();
    }

    function change(id, delta) {
      if (!PRODUCT[id]) return;
      var q = qty[id] || 0;
      var next = Math.max(0, Math.min(99, q + delta));
      if (next === q) return;
      if (next > 0) qty[id] = next; else delete qty[id];
      lastChange = PRODUCT[id].name + ': ' + pieces(next) + '.';
      render();
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
        var id;
        if ((id = btn.getAttribute('data-binc'))) change(id, 1);
        else if ((id = btn.getAttribute('data-bdec'))) change(id, -1);
      });
    });
    var reset = byId('ek2-builder-reset');
    if (reset) reset.addEventListener('click', function () {
      qty = {};
      lastChange = '';
      render();
    });
    addBtn.addEventListener('click', function () {
      if (addBtn.getAttribute('aria-disabled') === 'true') return;
      var items = builderItems();
      if (!items.length) return;
      add(items, { button: addBtn, open: true }).catch(noop);
    });
    render();
  }

  /* =====================================================================
     COPIAR CORREO (clipboard + respaldo de selección)
     ===================================================================== */
  function initCopy(scope) {
    var btn = within(scope, '#ek2-copy-email')[0];
    var emailEl = byId('ek2-footer-email');
    var status = byId('ek2-copy-status');
    if (!btn || !emailEl || !once(btn, 'copy')) return;
    function selectEmail() {
      try {
        var range = doc.createRange();
        range.selectNodeContents(emailEl);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } catch (e) { /* nada */ }
    }
    function legacyCopy() {
      selectEmail();
      var ok = false;
      try { ok = !!(doc.execCommand && doc.execCommand('copy')); } catch (e) { ok = false; }
      return ok;
    }
    function success() {
      if (status) status.textContent = '';
      flash(btn, 1600);
      announce(T.copied);
    }
    function failure() {
      selectEmail();
      if (status) status.textContent = T.copyFailed;
    }
    btn.addEventListener('click', function () {
      var text = emailEl.textContent.trim();
      var policyOk = true;
      try {
        if (doc.featurePolicy && doc.featurePolicy.allowsFeature) policyOk = doc.featurePolicy.allowsFeature('clipboard-write');
      } catch (e) { policyOk = true; }
      if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext && policyOk) {
        navigator.clipboard.writeText(text).then(success, function () { if (legacyCopy()) success(); else failure(); });
      } else if (legacyCopy()) {
        success();
      } else {
        failure();
      }
    });
  }

  /* =====================================================================
     CINTA DE SELLOS: duración por ancho (36 px/s) y pausa fuera de pantalla
     ===================================================================== */
  function initMarquee(scope) {
    var wrap = within(scope, '#ek2-marquee')[0];
    var track = wrap && $('#ek2-marquee-track', wrap);
    var list = track && $('.ek2-marquee__list', track);
    if (!wrap || !list || !once(wrap, 'marquee')) return;
    function setDuration() {
      var w = list.getBoundingClientRect().width;
      if (w > 0) track.style.setProperty('--marquee-d', (w / 36).toFixed(2) + 's');
    }
    if ('ResizeObserver' in window) new ResizeObserver(setDuration).observe(list);
    else setDuration();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { wrap.classList.toggle('is-paused', !en.isIntersecting); });
      }).observe(wrap);
    }
  }

  /* =====================================================================
     REVEAL al hacer scroll (parte visible: solo transform)
     ===================================================================== */
  var revealIO = null;
  function initReveal(scope) {
    if (reduced() || !('IntersectionObserver' in window)) return;
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target;
          el.setAttribute(el.hasAttribute('data-rvi') ? 'data-rvi' : 'data-rv', 'in');
          revealIO.unobserve(el);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
    }
    var vh = window.innerHeight || doc.documentElement.clientHeight;
    within(scope, '[data-rv], [data-rvi]').forEach(function (el) {
      if (!once(el, 'rv')) return;
      if (el.getBoundingClientRect().top > vh) {
        el.setAttribute(el.hasAttribute('data-rvi') ? 'data-rvi' : 'data-rv', 'pending');
        revealIO.observe(el);
      }
    });
  }

  /* =====================================================================
     NAV: subrayado fijo en la sección activa
     ===================================================================== */
  var navIO = null;
  function initActiveNav() {
    safe(function () {
      if (!('IntersectionObserver' in window)) return;
      if (navIO) navIO.disconnect();
      var sections = $$('[data-nav-section]');
      var visible = {};
      function update() {
        var current = null;
        sections.forEach(function (s) { if (visible[s.id]) current = s.getAttribute('data-nav-section'); });
        $$('.ek2-nav a[data-nav]').forEach(function (a) {
          if (a.getAttribute('data-nav') === current) a.setAttribute('aria-current', 'true');
          else a.removeAttribute('aria-current');
        });
      }
      navIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { visible[en.target.id] = en.isIntersecting; });
        update();
      }, { rootMargin: '-45% 0px -50% 0px' });
      sections.forEach(function (s) { navIO.observe(s); });
    });
  }

  /* ---------- Una pregunta enlazada desde otra página (/#faq-7-btn) llega abierta ---------- */
  function openHashAccordion() {
    safe(function () {
      var id = decodeURIComponent((window.location.hash || '').slice(1));
      if (!id) return;
      var el = byId(id);
      if (el && el.classList.contains('ek2-acc__btn') && el.getAttribute('aria-expanded') !== 'true') el.click();
    });
  }

  /* =====================================================================
     FICHA DE PRODUCTO (sections/ek2-product.liquid)
     Galería con scroll-snap (deslizar en celular) + miniaturas, cantidad,
     variantes (productos genéricos) y mensaje de promoción según el carrito.
     ===================================================================== */
  function initPdp(scope) {
    within(scope, '[data-ek2-pdp]').forEach(function (pdp) {
      if (!once(pdp, 'pdp')) return;

      /* ---------- Galería ---------- */
      var track = $('[data-pdp-track]', pdp);
      var slides = track ? $$('[data-pdp-slide]', track) : [];
      var thumbs = $$('[data-pdp-thumb]', pdp);
      var current = 0;
      function pauseOthers(i) {
        slides.forEach(function (s, j) {
          if (j === i) return;
          $$('video', s).forEach(function (v) { try { v.pause(); } catch (e) { /* nada */ } });
        });
      }
      function setCurrent(i) {
        if (i === current) return;
        current = i;
        thumbs.forEach(function (t) {
          t.setAttribute('aria-current', Number(t.getAttribute('data-pdp-thumb')) === i ? 'true' : 'false');
        });
        pauseOthers(i);
      }
      function goTo(i) {
        if (!track || !slides[i]) return;
        var left = slides[i].offsetLeft;
        try { track.scrollTo({ left: left, behavior: reduced() ? 'auto' : 'smooth' }); }
        catch (e) { track.scrollLeft = left; }
        setCurrent(i);
      }
      if (track && slides.length > 1) {
        var ticking = false;
        track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            var w = track.clientWidth || 1;
            setCurrent(Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w))));
          });
        }, { passive: true });
        thumbs.forEach(function (t) {
          t.addEventListener('click', function () { goTo(Number(t.getAttribute('data-pdp-thumb')) || 0); });
        });
      }

      /* ---------- Cantidad ---------- */
      var qty = $('[data-pdp-qty]', pdp);
      var steps = $$('[data-pdp-step]', pdp);
      function clampQty() {
        if (!qty) return 1;
        var n = Math.max(1, Math.min(99, Math.floor(Number(qty.value) || 1)));
        qty.value = String(n);
        steps.forEach(function (b) {
          var d = Number(b.getAttribute('data-pdp-step'));
          b.setAttribute('aria-disabled', (d < 0 && n <= 1) || (d > 0 && n >= 99) ? 'true' : 'false');
        });
        return n;
      }
      steps.forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qty || b.getAttribute('aria-disabled') === 'true') return;
          qty.value = String((Number(qty.value) || 1) + Number(b.getAttribute('data-pdp-step')));
          var n = clampQty();
          announce(T.qty + ': ' + n + '.');
        });
      });
      if (qty) {
        qty.addEventListener('change', clampQty);
        qty.addEventListener('blur', clampQty);
        clampQty();
      }

      /* ---------- Variantes (solo productos con opciones) ---------- */
      var addBtn = $('[data-pdp-add]', pdp);
      var select = $('[data-pdp-variant]', pdp);
      var variants = [];
      safe(function () {
        var json = $('[data-pdp-variants]', pdp);
        if (json) variants = JSON.parse(json.textContent) || [];
      });
      if (select && addBtn && variants.length) {
        select.addEventListener('change', function () {
          var id = Number(select.value);
          var v = null;
          variants.forEach(function (x) { if (Number(x.id) === id) v = x; });
          if (!v) return;
          addBtn.setAttribute('data-add', String(v.id));
          var price = $('[data-pdp-price]', pdp);
          if (price) price.textContent = centsMXN(v.price);
          var compare = $('[data-pdp-compare]', pdp);
          if (compare) {
            var onSale = Number(v.compare) > Number(v.price);
            compare.hidden = !onSale;
            compare.textContent = onSale ? centsMXN(v.compare) : '';
          }
          addBtn.disabled = !v.available;
          var label = $('[data-pdp-label]', addBtn);
          var soldout = $('[data-pdp-soldout]', addBtn);
          if (label) label.hidden = !v.available;
          if (soldout) soldout.hidden = !!v.available;
          safe(function () {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', String(v.id));
            window.history.replaceState(window.history.state, '', url.toString());
          });
        });
      }

      /* ---------- Suscripción (app Shopify Subscriptions): el plan elegido viaja en data-selling-plan ---------- */
      var planBox = $('[data-pdp-plan]', pdp);
      if (planBox && addBtn) {
        var freqBox = $('[data-plan-freq]', planBox);
        var freq = $('[data-pdp-freq]', planBox);
        var syncPlan = function () {
          var mode = $('[data-plan-mode]:checked', planBox);
          var sub = !!(mode && mode.value === 'sub' && freq && freq.value);
          if (freqBox) freqBox.hidden = !sub;
          if (sub) addBtn.setAttribute('data-selling-plan', freq.value); else addBtn.removeAttribute('data-selling-plan');
          pdp.classList.toggle('is-sub', sub);
          emit('ek2:plan', { sub: sub });
        };
        $$('[data-plan-mode]', planBox).forEach(function (r) { r.addEventListener('change', syncPlan); });
        if (freq) freq.addEventListener('change', syncPlan);
        /* ?plan=suscripcion (botón "Suscríbete" de los correos): la página abre con la suscripción elegida */
        var wantSub = false;
        try { wantSub = /^(suscripcion|sub)$/i.test(new URLSearchParams(window.location.search).get('plan') || ''); } catch (e) { wantSub = false; }
        var subRadio = wantSub && $('[data-plan-mode][value="sub"]', planBox);
        if (subRadio) {
          subRadio.checked = true;
          setTimeout(function () { planBox.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' }); }, 300);
        }
        syncPlan();
      }

      /* ---------- Promoción: el mismo mensaje del carrito, según las piezas de la línea ---------- */
      var promo = $('[data-pdp-promo]', pdp);
      var meter = $$('[data-pdp-meter] span', pdp);
      function syncPromo() {
        if (!cartState) return;
        var units = lineUnits(effectiveLines());
        if (promo) promo.textContent = promoMsg(units);
        meter.forEach(function (s, i) { s.classList.toggle('is-on', units >= i + 1); });
      }
      if (promo || meter.length) {
        doc.addEventListener('ek2:cart', syncPromo);
        syncPromo();
      }

      /* ---------- Compra por impulso: "Llévate también…" con el ahorro real del pedido ----------
         Pedido proyectado = lo que ya hay en el carrito + este producto con la cantidad elegida (si aún
         no está). Se sugiere la pareja del ritual que no esté en el carrito y se muestra cuánto sube
         de verdad el total (descuento por piezas y envío incluidos) y el ahorro total. */
      var up = $('[data-pdp-upsell]', pdp);
      var self = addBtn ? BY_VARIANT[Number(addBtn.getAttribute('data-add'))] : null;
      var PAIRS = {
        shampoo: ['acond', 'glowbomb', 'reset'], acond: ['shampoo', 'glowbomb', 'reset'],
        glowbomb: ['reset', 'shampoo', 'acond'], reset: ['glowbomb', 'shampoo', 'acond']
      };
      if (up && self && PAIRS[self.id]) {
        var upBtn = $('[data-up-add]', up);
        var suggestion = null;
        var selfInCart = false;
        /* lee la cantidad sin corregir el campo mientras se escribe */
        var readQty = function () { return qty ? Math.max(1, Math.min(99, Math.floor(Number(qty.value) || 1))) : 1; };
        var syncUpsell = function () {
          if (!cartState) return;
          if (pdp.classList.contains('is-sub')) { up.hidden = true; return; }
          var counts = {};
          effectiveLines().forEach(function (l) {
            var p = BY_VARIANT[l.item.variant_id];
            if (p) counts[p.id] = (counts[p.id] || 0) + l.qty;
          });
          selfInCart = !!counts[self.id];
          var basket = Object.keys(counts).map(function (id) { return { id: id, qty: counts[id] }; });
          if (!selfInCart) basket.push({ id: self.id, qty: readQty() });
          suggestion = null;
          PAIRS[self.id].some(function (id) {
            var p = PRODUCT[id];
            if (p && p.available && !counts[id]) { suggestion = p; return true; }
            return false;
          });
          if (!suggestion) { up.hidden = true; return; }
          var base = priceFor(basket);
          var withIt = priceFor(basket.concat([{ id: suggestion.id, qty: 1 }]));
          var extra = Math.round((withIt.grandTotal - base.grandTotal) * 100) / 100;
          var img = $('[data-up-img]', up);
          var src = (suggestion.images && (suggestion.images.cut || suggestion.images.pack)) || '';
          if (img && src && img.getAttribute('src') !== src) { img.src = src; img.alt = suggestion.name; }
          $('[data-up-title]', up).textContent = 'Llévate también ' + suggestion.name;
          var old = $('[data-up-old]', up);
          old.textContent = extra < suggestion.price ? formatMoney(suggestion.price) : '';
          old.hidden = !(extra < suggestion.price);
          $('[data-up-extra]', up).textContent = 'solo +' + formatMoney(extra);
          var save = 'Ahorras ' + formatMoney(withIt.savings) + ' en tu pedido';
          if (withIt.freeShipping && !base.freeShipping) save += ' y tu envío se vuelve gratis';
          else if (withIt.freeShipping) save += ' + envío gratis';
          $('[data-up-save]', up).textContent = save + '.';
          var label = $('[data-up-label]', up);
          if (label) label.textContent = selfInCart ? 'Agregar' : 'Agregar los dos';
          if (upBtn) upBtn.setAttribute('aria-label', selfInCart
            ? 'Agregar ' + suggestion.name + ' al carrito'
            : 'Agregar ' + self.name + ' y ' + suggestion.name + ' al carrito');
          up.hidden = false;
        };
        if (upBtn) upBtn.addEventListener('click', function () {
          if (!suggestion) return;
          var items = [{ id: suggestion.variantId, quantity: 1 }];
          if (!selfInCart) items.unshift({ id: self.variantId, quantity: readQty() });
          add(items, { button: upBtn, open: true }).catch(noop);
        });
        doc.addEventListener('ek2:cart', syncUpsell);
        doc.addEventListener('ek2:plan', syncUpsell);
        steps.forEach(function (b) { b.addEventListener('click', function () { setTimeout(syncUpsell, 0); }); });
        if (qty) { qty.addEventListener('change', syncUpsell); qty.addEventListener('input', syncUpsell); }
        syncUpsell();
      }
    });
  }

  /* =====================================================================
     ARRANQUE
     ===================================================================== */
  function initScope(scope) {
    safe(function () { hydratePrices(scope); });
    safe(function () { initHeroVideo(scope); });
    safe(function () { initMotionToggle(scope); });
    safe(function () { initCards(scope); });
    safe(function () { initTabs(scope); });
    safe(function () { initBuilder(scope); });
    safe(function () { initCopy(scope); });
    safe(function () { initMarquee(scope); });
    safe(function () { initReveal(scope); });
    safe(function () { initPdp(scope); });
  }

  function boot() {
    var cb = cartBtn();
    if (cb) cb.setAttribute('aria-expanded', 'false');
    initChrome();
    initScope(doc);
    safe(heroReady);
    initActiveNav();
    openHashAccordion();

    /* Carrito: /cart.js es la fuente de verdad (también al volver con "atrás" desde el pago) */
    fetchCart().catch(noop);
    window.addEventListener('pageshow', function (e) {
      var c = byId('ek2-cart-checkout');
      if (c) c.removeAttribute('aria-busy');
      if (e.persisted) fetchCart().catch(noop);
    });
    /* Al volver a la pestaña (el carrito pudo cambiar en otra pestaña o en el pago) */
    doc.addEventListener('visibilitychange', function () {
      if (doc.hidden || hasPending() || Date.now() - lastFetchAt < 2000) return;
      fetchCart().catch(noop);
    });

    /* Dawn (página /cart) avisa cuando cambia el carrito: se sincroniza el contador y el drawer */
    safe(function () {
      if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        window.subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
          if (ev && ev.source === 'ek2') return;
          fetchCart().catch(noop);
        });
      }
    });

    /* Editor de temas: al volver a pintar una sección se inicializa de nuevo */
    doc.addEventListener('shopify:section:load', function (e) {
      var scope = e.target;
      initScope(scope);
      if (scope.querySelector && scope.querySelector('#ek2-cart')) {
        drawerOpen = false;
        menuOpen = false;
        toastVisible = false;
        setPageInert(false);
        root.classList.remove('ek2-locked');
        initChrome();
        renderCart();
        updateCount(displayUnits(), displayUnits());
      }
      initActiveNav();
    });
    doc.addEventListener('shopify:section:unload', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('#ek2-cart')) {
        if (drawerOpen) { setPageInert(false); root.classList.remove('ek2-locked'); }
        drawerOpen = false;
        menuOpen = false;
      }
    });
  }

  /* API pública */
  window.ek2 = {
    __ready: true,
    add: add,
    open: function (opener) { openCart(opener); },
    close: function () { closeCart(); },
    refresh: refresh,
    priceFor: priceFor,
    formatMoney: formatMoney,
    formatMXN: formatMXN,
    promoMessage: promoMsg,
    products: PRODUCTS,
    bundles: BUNDLES,
    promo: PROMO,
    shippingFlat: SHIPPING_FLAT_CENTS,
    get cart() { return cartState; }
  };

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
